// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"7d696550","453":"c917ed66","698":"21c982f0"}[chunkId] + ".chunk.js";
};